import { apiPharmaInstance } from 'utils/axios';

// get
export const getDocumentation = async (posId) => {
    try {
        return apiPharmaInstance
            .get(`api/points-of-sale/${posId}/documents`)
            .then((res) => res.data.data)
            .catch((e) => {
                console.error(e);
            });
    } catch (ex) {
        console.error(ex.message);
    }
};